import { useState } from 'react';
import LegalModal from './LegalModal';

const FooterSection = () => {
  const [legalOpen, setLegalOpen] = useState<'mentions' | 'confidentialite' | null>(null);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <LegalModal type={legalOpen} onClose={() => setLegalOpen(null)} />

      <footer className="w-full" style={{ background: 'linear-gradient(135deg, #002060 0%, #003580 50%, #1a8abf 100%)' }}>
        {/* Main footer */}
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Col 1 – Brand */}
            <div className="lg:col-span-1">
              <div className="flex items-center gap-3 mb-5">
                <img
                  src="https://public.readdy.ai/ai/img_res/17e880d1-e005-4ee7-9be4-7e3c630d6c8c.png"
                  alt="Polar Clim"
                  className="h-14 w-auto object-contain"
                />
                <div>
                  <p className="font-black text-white text-lg leading-tight">Polar Clim</p>
                  <p className="text-white/60 text-xs">Climatisation &amp; PAC</p>
                </div>
              </div>
              <p className="text-white/70 text-sm leading-relaxed mb-3">
                Votre spécialiste certifié en climatisation et pompes à chaleur à Nice et dans les alentours. Confort, performance et qualité.
              </p>
              <p className="text-white/60 text-sm font-semibold mb-5">Buisson Marc – Gérant</p>
              <div className="flex gap-3">
                <a
                  href="tel:0651341160"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/15 hover:bg-white/25 transition-all cursor-pointer"
                >
                  <i className="ri-phone-line text-white text-lg" />
                </a>
                <a
                  href="mailto:Horn@gmx.fr"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/15 hover:bg-white/25 transition-all cursor-pointer"
                >
                  <i className="ri-mail-line text-white text-lg" />
                </a>
              </div>
            </div>

            {/* Col 2 – Contact */}
            <div>
              <h4 id="footer-contact" className="font-bold text-white text-base mb-2">
                <a href="#contact">Contact</a>
              </h4>
              <div className="w-8 h-0.5 mb-5 bg-[#4ab8d0]" />
              <ul className="flex flex-col gap-4">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-[#4ab8d0] text-sm" />
                  </div>
                  <span className="text-white/70 text-sm">5 Place de la Victoire,<br />06440 Blausasc</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0">
                    <i className="ri-phone-line text-[#4ab8d0] text-sm" />
                  </div>
                  <a href="tel:0651341160" className="text-white/70 text-sm hover:text-white transition-colors">06 51 34 11 60</a>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line text-[#4ab8d0] text-sm" />
                  </div>
                  <a href="mailto:Horn@gmx.fr" className="text-white/70 text-sm hover:text-white transition-colors">Horn@gmx.fr</a>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-time-line text-[#4ab8d0] text-sm" />
                  </div>
                  <span className="text-white/70 text-sm">Lun – Sam<br />8h00 – 20h00</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 py-5 flex flex-wrap items-center justify-between gap-4">
            <p className="text-white/50 text-xs">
              © 2026 Polar Clim · SIRET : 988 012 597 00015
            </p>
            <div className="flex items-center gap-4">
              <button
                onClick={() => setLegalOpen('mentions')}
                className="text-white/60 text-xs font-medium hover:text-white cursor-pointer whitespace-nowrap transition-colors"
              >
                Mentions légales
              </button>
              <span className="text-white/20">|</span>
              <button
                onClick={() => setLegalOpen('confidentialite')}
                className="text-white/60 text-xs font-medium hover:text-white cursor-pointer whitespace-nowrap transition-colors"
              >
                Politique de confidentialité
              </button>
            </div>
          </div>
          {/* Credit */}
          <div className="border-t border-white/5 py-3">
            <p className="text-center text-white/30 text-xs tracking-wide">
              Site réalisé par <span className="text-white/50 font-medium">Ruben Bagniard</span>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterSection;
